/* eslint-disable react/prop-types */
import React from "react";
import styled from "styled-components";
import { spacing4, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import { Ghost } from "@churchofjesuschrist/eden-buttons";
import { Text3 } from "@churchofjesuschrist/eden-text";
const buttonOffsetMarginTop = `calc(-${spacing4} - 1.5px)`;
const buttonOffsetMarginBottom = `calc(-${spacing8} + 1px)`;
const CustomRow = styled.div.withConfig({
  componentId: "sc-12wf34s-0"
})(["pointer-events:auto;display:flex;align-items:center;"]);
const CustomText4 = styled(Text3).withConfig({
  componentId: "sc-12wf34s-1"
})(["flex:1;"]);
const CustomGhost = styled(Ghost).withConfig({
  componentId: "sc-12wf34s-2"
})(["white-space:nowrap;margin-block-start:", ";margin-block-end:", ";margin-inline-start:", ";"], buttonOffsetMarginTop, buttonOffsetMarginBottom, spacing8);

const Body = _ref => {
  let {
    action,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(CustomRow, {
    rowGapSize: "0",
    columnGapSize: "8",
    verticalAlign: "center"
  }, /*#__PURE__*/React.createElement(CustomText4, null, children), action && /*#__PURE__*/React.createElement(CustomGhost, {
    small: true,
    onClick: action.onClick,
    "data-testid": "onClick-button"
  }, /*#__PURE__*/React.createElement("strong", null, action.message)));
};

export default Body;